import styled, { css } from 'styled-components';

export type Spacing = 'default' | 'compact';

export const IssueStatussWrapperStyled = styled.span<{ spacing: Spacing }>`
  ${({ spacing }) => {
    return spacing === 'default'
      ? css`
          margin: 0 4px;
        `
      : css`
          margin: 0;
        `;
  }}
`;
